import {
  AddLocationResponse,
  UpsertLocationRequestDTO,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useAddLocation(onSuccess: (data: AddLocationResponse) => void) {
  const url = `/v2/orm/locations`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<
    AddLocationResponse,
    UpsertLocationRequestDTO
  >(request, {
    onSuccessInvalidationKeys: [['locations']],
    onSuccess,
  });
}

export default useAddLocation;
